import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { listOrganizations, deleteOrganization } from "../lib/api";
import { Plus, Building2, Trash2, Pencil, FileBarChart2, LineChart } from "lucide-react";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Organizations() {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => listOrganizations().then((d) => setOrgs(d)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const onDelete = async (id, name) => {
    if (!window.confirm(`"${name}" kuruluşunu ve tüm raporlarını silmek istediğinizden emin misiniz?`)) return;
    await deleteOrganization(id);
    toast.success("Kuruluş silindi");
    load();
  };

  return (
    <div className="px-6 md:px-14 py-10 md:py-14 max-w-6xl">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-2">Kayıtlı Tesisler</div>
          <h1 className="font-display text-4xl sm:text-5xl font-semibold">Tesisler</h1>
        </div>
        <Link to="/organizations/new" data-testid="add-org-btn">
          <Button size="lg" className="rounded-full h-12 px-7 gap-2">
            <Plus className="size-4" /> Yeni Tesis
          </Button>
        </Link>
      </div>

      {loading ? (
        <div className="text-muted-foreground">Yükleniyor…</div>
      ) : orgs.length === 0 ? (
        <div className="rounded-2xl border border-dashed p-14 text-center">
          <Building2 className="size-10 mx-auto text-muted-foreground mb-3" strokeWidth={1.3} />
          <div className="font-display text-xl mb-1">Henüz tesis eklenmemiş</div>
          <div className="text-sm text-muted-foreground mb-5">İlk otel veya tesisinizi ekleyin.</div>
          <Link to="/organizations/new"><Button className="rounded-full gap-2"><Plus className="size-4" /> Tesis Ekle</Button></Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {orgs.map((o) => (
            <div key={o.id} data-testid={`org-row-${o.id}`}
                 className="p-5 rounded-2xl border border-border bg-card card-hover flex gap-4">
              <div className="size-14 rounded-xl bg-primary/10 flex items-center justify-center overflow-hidden flex-shrink-0">
                {o.logo_base64 ? (
                  <img src={o.logo_base64} alt="" className="object-contain w-full h-full" />
                ) : (
                  <Building2 className="size-6 text-primary" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display text-lg font-semibold truncate">{o.name}</div>
                <div className="text-xs text-muted-foreground truncate">{o.address || "—"}</div>
                <div className="text-xs text-muted-foreground mt-1">
                  {o.email && <span>{o.email}</span>}
                  {o.phone && <span> · {o.phone}</span>}
                </div>
                <div className="mt-3 flex gap-2">
                  <Link to={`/organizations/${o.id}/edit`}>
                    <Button size="sm" variant="outline" className="gap-1.5 h-8" data-testid={`org-edit-${o.id}`}>
                      <Pencil className="size-3" /> Düzenle
                    </Button>
                  </Link>
                  <Link to={`/reports/new?org=${o.id}`}>
                    <Button size="sm" variant="outline" className="gap-1.5 h-8" data-testid={`org-newreport-${o.id}`}>
                      <FileBarChart2 className="size-3" /> Rapor · {o.report_count}
                    </Button>
                  </Link>
                  {o.report_count > 0 && (
                    <Link to={`/organizations/${o.id}/comparison`}>
                      <Button size="sm" variant="outline" className="gap-1.5 h-8" data-testid={`org-compare-${o.id}`}>
                        <LineChart className="size-3" /> Karşılaştır
                      </Button>
                    </Link>
                  )}
                  <Button size="sm" variant="ghost" onClick={() => onDelete(o.id, o.name)}
                          className="gap-1.5 h-8 text-destructive hover:text-destructive hover:bg-destructive/10"
                          data-testid={`org-delete-${o.id}`}>
                    <Trash2 className="size-3" />
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
